import { render } from "./NavigationPage.vue?vue&type=template&id=2372b725&scoped=true"
import script from "./NavigationPage.vue?vue&type=script&lang=js"
export * from "./NavigationPage.vue?vue&type=script&lang=js"

import "./NavigationPage.vue?vue&type=style&index=0&id=2372b725&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2372b725"]])

export default __exports__